<template>
<div class="row g-3">
    <div v-for="requirement in requirements" :key="requirement.id" class="col-12">

        <label class="form-label fw-semibold"> {{ requirement.title }}
            <span v-if="!requirement.is_required" class="text-muted">
                (Optional)
            </span>
        </label>

        <div v-if="requirement.description" class="small text-muted mb-1">
            {{ requirement.description }}
        </div>

        <!-- INPUT -->
        <input v-if="requirement.type === 'pro_input'" type="text" class="form-control"
            v-model="form[requirement.id]" :placeholder="`Enter ${ $filters.textFromSlug(requirement.name) }`"
        />

        <!-- TEXTAREA -->
        <textarea v-else-if="requirement.type === 'pro_textarea'" class="form-control" rows="2" 
            v-model="form[requirement.id]" :placeholder="`Provide ${ $filters.textFromSlug(requirement.name) }`"
        ></textarea>

        <!-- SELECT -->
        <select v-else-if="requirement.type === 'pro_select'" class="form-select"
            v-model="form[requirement.id]"
        >
            <option disabled value="">-- Select --</option>
            <option v-for="(opt, i) in requirement.options" :key="i" :value="opt">
                {{ opt }}
            </option>
        </select>

        <!-- RADIO -->
        <div v-else-if="requirement.type === 'pro_radio'">
            <div v-for="(opt, i) in requirement.options" :key="i" class="form-check">
                <input class="form-check-input" type="radio" :name="'req_' + requirement.id"
                :value="opt" v-model="form[requirement.id]" :id="'req_' + requirement.id + '_' + i">
                <label class="form-check-label" :for="'req_' + requirement.id + '_' + i">
                    {{ opt }}
                </label>
            </div>
        </div>

        <!-- CHECKBOX -->
        <div v-else-if="requirement.type === 'pro_checkbox'">
            <div v-for="(opt, i) in requirement.options" :key="i" class="form-check">
                <input class="form-check-input" type="checkbox" :value="opt" 
                v-model="form[requirement.id]" :id="'req_' + requirement.id + '_' + i">
                <label class="form-check-label" :for="'req_' + requirement.id + '_' + i">
                    {{ opt }}
                </label>
            </div>
        </div>

        <!-- ERROR -->
        <div v-if="errors[requirement.id]"
             class="text-danger small mt-1">
            {{ errors[requirement.id] }}
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        requirements: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            form: {},
            errors: {}
        };
    },

    watch: {
        form: {
            deep: true,
            handler() {
                // Revalidate only fields that currently have errors
                Object.keys(this.errors).forEach(key => {
                    const req = this.requirements.find(r => r.id == key);
                    if (req) this.validateField(req);
                });
            }
        }
    },
    methods: {
        initialize() {
            this.requirements.forEach(req => {
                this.form[req.id] = req.type === 'pro_checkbox' ? [] : '';
            });
        },
        validateField(req) {
            const value = this.form[req.id];

            if (!req.is_required) {
                delete this.errors[req.id];
                return true;
            }

            if (req.type === 'pro_checkbox') {
                if (!value || !value.length) {
                    this.errors[req.id] = req.required_text || "This field is required.";
                    return false;
                }
            } else {
                if (!value) {
                    this.errors[req.id] = req.required_text || "This field is required.";
                    return false;
                }
            }

            // Field valid, remove error
            delete this.errors[req.id];
            return true;
        },

        validate() {
            let valid = true;
            this.requirements.forEach(req => {
                if (!this.validateField(req)) valid = false;
            });
            return valid;
        },

        getPayload() {
            return this.requirements.map(req => {
                let value = this.form[req.id] ?? null;
                if (req.type === 'pro_checkbox' && Array.isArray(value)) {
                    value = value.length ? value.join(', ') : null;
                }
                return { id: req.id, value };
            });
        }
    },

    mounted() {
        this.initialize();
    }
};
</script>